<template>
  <li :key="item.id">
    <div @click="select" v-bind:class="{ active: isActive }">
      {{item.name}}
      <font-awesome-icon v-if="!item.isOpen && item.children.length > 0"
                         @click="toggle()"
                         :icon="['far','caret-right']"/>
      <font-awesome-icon v-if="item.isOpen && item.children.length > 0"
                         @click="toggle()"
                         :icon="['far','caret-down']"/>
      <font-awesome-icon
          v-if="parentFolderId !== null"
          class="float-right"
          @click="showDeleteModal()"
          v-on:ok="deleteThisFolder()"
          :icon="['far','trash-alt']"/>
    </div>
    <!--<b-modal :ref="modalRef" lazy>-->
      <!--<h4 slot="header">Confirm Folder Deletion</h4>-->
      <!--<p>Are you sure you want to delete this folder?</p>-->
      <!--<p>All projects in this folder will be moved to the parent folder.</p>-->
    <!--</b-modal>-->

    <ul v-show="item.isOpen">
      <!--<ul v-show="true">-->
      <recursive-folder
          @folder-selected="propagateSelect"
          class="item"
          v-for="(child,index) in item.children"
          :key="index"
          :item="child"
          :active-folder-id="activeFolderId"
          :parent-folder-id="item.id"
          @add-item="$emit('add-item',$event)"
          v-on:change-folder="$emit('change-folder', $event)"
      ></recursive-folder>
    </ul>
  </li>
</template>

<script>

  import { mapActions } from 'vuex';

  export default {
    name: "RecursiveFolder",
    props: {
      item: Object,
      activeFolderId: Number,
      parentFolderId: {
        required: false,
        default: null
      },
    },
    data: function (){
      return {
        isOpen: true
      }
    },
    computed: {
      isActive(){
        const isActive = (this.item.id === this.activeFolderId);
        return isActive
      },
      modalRef(){
        return this.item.id + "FolderDeleteModal"
      }
    },
    methods: {
      ...mapActions('rx',['deleteFolder']),
      toggle(){
        this.item.isOpen = !this.item.isOpen
      },
      addItem: function (item){
        item.children.push({
          name: 'New Folder',
          isOpen: true,
          children: []
        })
      },
      propagateSelect(data){
        // console.log("Propagating selected in "+ this.item.id + ": ", data);
        this.$emit('folder-selected', data);
      },
      select(){
        // console.log('Folder ' + this.item.name + ' (' + this.item.id + ') selected');
        this.$emit('folder-selected', this.item)
      },
      showDeleteModal(){
        // this.$refs[this.modalRef].show()
        this.$bvModal.msgBoxConfirm("Are you sure you want to delete this folder? All projects will be transferred to the parent folder. This action cannot be undone.").then(value => {
          console.log("MsgBox result: ", value);
          if (value === true){
            console.log("Starting delete", this.item.id);
            this.deleteFolder(this.item.id).then( () => {

              console.log("Changing folder");
              this.$emit('change-folder', this.parentFolderId)

            })
          }
        })
      },
    }
  }
</script>

<style scoped>
  .dragArea {
    outline: 1px dashed;
  }

  .active {
    font-weight: bold;
  }

</style>